interface ScoreDeltaBadgeProps {
  delta: number | null;
  size?: 'sm' | 'md';
}

export default function ScoreDeltaBadge({ delta, size = 'sm' }: ScoreDeltaBadgeProps) {
  const pad = size === 'md' ? 'px-2 py-0.5 text-xs' : 'px-1.5 py-0.5 text-[10px]';

  if (delta === null) {
    return (
      <span
        className={`inline-flex items-center gap-0.5 rounded-full bg-background-200 font-semibold text-foreground-600 ${pad}`}
      >
        첫 기록
      </span>
    );
  }

  if (delta === 0) {
    return (
      <span
        className={`inline-flex items-center gap-0.5 rounded-full bg-background-200 font-semibold text-foreground-600 ${pad}`}
      >
        <i className="ri-subtract-line"></i>0
      </span>
    );
  }

  const up = delta > 0;
  return (
    <span
      className={`inline-flex items-center gap-0.5 rounded-full font-semibold ${pad} ${
        up ? 'bg-primary-100 text-primary-700' : 'bg-accent-100 text-accent-800'
      }`}
    >
      <i className={up ? 'ri-arrow-up-line' : 'ri-arrow-down-line'}></i>
      {Math.abs(delta)}
    </span>
  );
}